import React from 'react';
import './payments.scss';
import Icon from 'components/mweb/Icon/Icon';
import Button from '../../common/Button/Button';
import Drawer from 'components/common/Drawer';
import Input from 'components/mweb/Input/Input';
import { setAppNotification } from 'hb-redux-store/initial.action';
import SimpleModal from 'components/mweb/Modal/SimpleModal';
import { connect } from 'react-redux';
import RazorpayService from 'hb-redux-store/util/RazorpayService';
import { CreditCardValidationService } from 'hb-redux-store/util/CreditCardValidationService';
import { PAYMENT_GATEWAYS, SOURCE } from 'hb-redux-store/util/constantServices';
const validationService = new CreditCardValidationService();
const Cards = props => {
  const {
    title,
    details,
    selectedMode,
    source = '',
    ctaText = 'Place Order',
  } = props;
  const { onPaymentModeChange, onPlaceOrder, pgId } = props;
  const initialCard = {
    saveCard: true,
    cardNo: '',
    expiry: '',
    cvv: '',
    token: '',
    name: '',
    invalidCardNo: false,
    maxCardLength: 19,
    maxCvvLength: 3,
    cardIcon: 'icon-payment-dummy-card',
  };
  const cvvIllustration =
    'https://ik.imagekit.io/iwcam3r8ka/prod/random/202007/9e7476e4-89ca-465a-9a0a-57718492eb7f.svg';
  const [cvvModalVisible, showCvvModalVisible] = React.useState(false);
  const [showNewCardModal, setNewCardModal] = React.useState(false);
  const [cardDetails, setCardDetails] = React.useState(initialCard);
  const onCancel = () => {
    setCardDetails(initialCard);
    setNewCardModal(false);
  };
  const onSavedCardSelection = card => {
    if (source === SOURCE.ACCOUNTS) return;
    const newCard = { ...initialCard, token: card.tokenId };
    const cardType = validationService.getCardFromBrand(card.network);
    if (cardType) newCard.maxCvvLength = cardType.maxCvvLength;
    setCardDetails(newCard);
    onPaymentModeChange(card.tokenId);
  };
  const onPay = () => {
    //validate data, show errors or call onPlaceOrder
    if (cardDetails.token && validateCVV()) {
      const payDetails = {
        token: cardDetails.token,
        'card[cvv]': cardDetails.cvv,
        mode: 'pol',
        payVia: 'savedCard',
      };
      if (pgId === PAYMENT_GATEWAYS.PAYU.id) {
        payDetails.store_card_token = cardDetails.token;
        payDetails.ccvv = cardDetails.cvv;
        delete payDetails['card[cvv]'];
      }
      console.log('Pay Details: ', payDetails);
      onPlaceOrder(payDetails);
    } else if (
      validateCreditCard() &&
      validateExpiry() &&
      validateCVV() &&
      validateName()
    ) {
      const [month, year] = cardDetails.expiry.split('/');
      let payDetails = {};
      if (pgId === PAYMENT_GATEWAYS.RAZORPAY.id) {
        payDetails = {
          mode: 'pol',
          payVia: 'CC',
          method: 'card',
          ...validationService.getBinAndLast4(cardDetails.cardNo),
          cardType: cardDetails.cardType,
          'card[number]': cardDetails.cardNo,
          'card[expiry_month]': month,
          'card[expiry_year]': year,
          'card[cvv]': cardDetails.cvv,
          'card[name]': cardDetails.name,
          contact: cardDetails.name,
          save: cardDetails.saveCard ? 1 : 0,
        };
      } else if (pgId === PAYMENT_GATEWAYS.PAYU.id) {
        payDetails = {
          /// Needed for HB-API
          mode: 'pol',
          payVia: 'CC',
          method: 'card',
          ...validationService.getBinAndLast4(cardDetails.cardNo),
          cardType: cardDetails.cardType,
          ///
          pg: 'CC',
          bankcode: 'CC',
          ccnum: cardDetails.cardNo,
          card_name: cardDetails.name,
          ccvv: cardDetails.cvv,
          ccexpmon: month, // Mandatory 2 digits
          ccexpyr: `20${year}`, // Mandatory 4 digits
          store_card: cardDetails.saveCard ? 1 : 0,
        };
      }
      onPlaceOrder(payDetails);
    } else {
      // show error
      props.setAppNotification('Please update invalid fields.');
    }
  };
  const setExpiry = ({ expiry }) => {
    // if (expiry.length === 1 && Number(expiry) > 2) {
    //   expiry += '/';
    // } else if (
    //   expiry.length === 2 &&
    //   Number(expiry) > 0 &&
    //   Number(expiry) < 13
    // ) {
    //   expiry += '/';
    // }
    let updatedExpiry = expiry;
    if (expiry?.length === 3 && !expiry?.includes('/')) {
      updatedExpiry = expiry.slice(0, 2) + '/' + expiry.slice(2);
    }
    setCardDetails({ ...cardDetails, expiry: updatedExpiry });
  };

  const validateExpiry = () => {
    const { expiry } = cardDetails;
    const date = new Date();
    let invalidExpiry = false;
    const [monthStr, yearStr] = expiry.split('/');
    const month = monthStr && Number(monthStr);
    const year = yearStr && Number(yearStr);
    if (!month || month < 0 || month > 12) invalidExpiry = true;
    if (
      !year ||
      year < date.getFullYear() % 2000 ||
      year > (date.getFullYear() % 2000) + 20
    )
      invalidExpiry = true;
    if (year === date.getFullYear() % 2000 && month < date.getMonth() + 1) {
      invalidExpiry = true;
    }
    setCardDetails({ ...cardDetails, invalidExpiry });
    return !invalidExpiry;
  };

  const validateCVV = () => {
    const { cvv } = cardDetails;
    const invalidCvv = `${cvv}`.length < 3 || `${cvv}`.length > 4;
    setCardDetails({ ...cardDetails, invalidCvv });
    return !invalidCvv;
  };
  const validateName = () => {
    const { name } = cardDetails;
    const invalidName = !name.length;
    setCardDetails({ ...cardDetails, invalidName });
    return !invalidName;
  };

  const formatCreditCard = ({ cardNo }) => {
    const cardType = validationService.cardFromNumber(cardNo);
    const formattedCardNo = validationService.reFormatCardNumber(
      cardNo,
      cardType
    );
    const newDetails = { ...cardDetails, cardNo: formattedCardNo };
    if (cardType) {
      newDetails.cardType = cardType?.type;
      newDetails.maxCardLength = cardType?.maxCardLength;
      newDetails.maxCvvLength = cardType?.maxCvvLength;
      newDetails.cardIcon = getCardIcon(cardType.type);
    }
    setCardDetails(newDetails);
  };
  const validateCreditCard = () => {
    const { cardNo } = cardDetails;
    const isValidCard = cardNo ? validationService.isValidCardNo(cardNo) : true;
    setCardDetails({
      ...cardDetails,
      // invalidCardNo: !!(cardNo && !isValidCard),
      invalidCardNo: !isValidCard,
    });

    return isValidCard;
  };

  const getMaskedCard = card => {
    if (pgId === PAYMENT_GATEWAYS.PAYU.id) {
      return card.last4;
    } else if (pgId === PAYMENT_GATEWAYS.RAZORPAY.id) {
      return `xxxx-xxxx-xxxx-${card.last4}`;
    }
  };

  const getCardIcon = brand => {
    const availableIcons = ['visa', 'mastercard', 'rupay', 'amex'];
    return availableIcons.indexOf(brand.toLowerCase()) > -1
      ? `icon-payment-card-${brand.toLowerCase()}`
      : 'icon-payment-dummy-card';
  };

  const saveCard = () => {};
  const deleteCard = tokenId => {};
  return (
    <React.Fragment>
      <div className="desktop-payment-mode-panel saved-card">
        <div className="desktop-payment-mode-panel--title">{title}</div>
        {details &&
          details.length > 0 &&
          details.map(card => {
            const cardIcon = getCardIcon(card.network);
            return (
              <React.Fragment key={card.tokenId}>
                <div
                  className={`desktop-payment-mode-panel--item ${
                    selectedMode === card.tokenId ? 'active' : ''
                  }`}
                  key={card.tokenId}
                  onClick={() => onSavedCardSelection(card)}
                >
                  <div className="desktop-payment-mode-panel--item--illustration">
                    <Icon class={cardIcon} height={26} width={45} />
                  </div>
                  <div className="desktop-payment-mode-panel--item--name">
                    {card.name && (
                      <span>
                        {card.name}
                        <br />
                      </span>
                    )}
                    {getMaskedCard(card)}
                  </div>
                  {source !== SOURCE.ACCOUNTS && (
                    <div className="desktop-payment-mode-panel--item--radio">
                      {selectedMode === card.tokenId ? (
                        <Icon size={17} class="icon-common-radio-selected" />
                      ) : (
                        <Icon size={17} class="icon-common-radio-unselected" />
                      )}
                    </div>
                  )}
                  {/*{source === SOURCE.ACCOUNTS && (*/}
                  {/*  <Button*/}
                  {/*    onClick={() => deleteCard(card.tokenId)}*/}
                  {/*    className="button action-link address-card--delete-action"*/}
                  {/*  >*/}
                  {/*    Delete*/}
                  {/*  </Button>*/}
                  {/*)}*/}
                </div>
                {selectedMode === card.tokenId && (
                  <div className="saved-card-info">
                    <Input
                      type="password"
                      className="saved-card-info--expiry"
                      onChange={({ cvv }) =>
                        setCardDetails({ ...cardDetails, cvv })
                      }
                      value={cardDetails.cvv}
                      name="cvv"
                      placeholder="CVV *"
                      autoComplete="off"
                      maxLength={cardDetails.maxCvvLength}
                      dataPrivate="lipsum"
                    />
                    <Button
                      className="button button-primary medium"
                      onClick={onPay}
                    >
                      {ctaText}
                    </Button>
                  </div>
                )}
              </React.Fragment>
            );
          })}
        <div className="desktop-payment-mode-panel--cta justify-content--space-between">
          <div className="flex-align-items-center">
            <Icon
              size={50}
              class="icon-payment-mastercard desktop-payment-mode--icon"
            />
            <Icon
              size={50}
              class="icon-payment-visa desktop-payment-mode--icon"
            />
            <Icon
              size={50}
              class="icon-payment-rupay desktop-payment-mode--icon"
            />
            <span className="desktop-payment-mode-panel--cta--more-text">
              & more
            </span>
          </div>
          {source !== SOURCE.ACCOUNTS && (
            <Button
              className="desktop-payment-mode-panel--add-card  button action-link more"
              onClick={() => {
                onPaymentModeChange();
                setCardDetails(initialCard);
                setNewCardModal(true);
              }}
            >
              {!source ? 'Pay using new card' : 'Add new card'}
            </Button>
          )}
        </div>
      </div>
      <div className="desktop-payments-section-divider"></div>
      <Drawer
        title={!source ? 'PAY USING NEW CARD' : 'ADD NEW CARD'}
        placement="right"
        closable={true}
        onClose={onCancel}
        visible={showNewCardModal}
        destroyOnClose={true}
        maskClosable={false}
        width={500}
        afterVisibleChange={RazorpayService.initRazorpay}
        className="desktop-add-new-card"
      >
        <div className="desktop-add-new-card--card-no">
          <Input
            type="mobile"
            className="desktop-add-new-card--card-no--input"
            onChange={formatCreditCard}
            value={cardDetails.cardNo}
            name="cardNo"
            autoFocus
            placeholder="Card Number *"
            maxLength={cardDetails.maxCardLength}
            hasError={cardDetails.invalidCardNo}
            errorMsg="Invalid card no."
            onBlur={validateCreditCard}
            dataPrivate="lipsum"
          />
          <Icon
            class={`desktop-add-new-card--card-no--card-icon ${cardDetails.cardIcon}`}
            height={20}
            width={35}
          />
        </div>
        <div className="desktop-add-new-card--card-expiry">
          <Input
            type="mobile"
            className="desktop-add-new-card--card-expiry--input"
            onChange={setExpiry}
            value={cardDetails.expiry}
            name="expiry"
            maxLength={5}
            placeholder="Expiry (MM/YY) *"
            hasError={cardDetails.invalidExpiry}
            errorMsg="Invalid expiry data."
            onBlur={validateExpiry}
          />
        </div>
        <div className="desktop-add-new-card--card-cvv">
          <Input
            type="password"
            className="desktop-add-new-card--card-cvv--input"
            onChange={({ cvv }) => setCardDetails({ ...cardDetails, cvv })}
            value={cardDetails.cvv}
            name="cvv"
            placeholder="CVV *"
            autoComplete="off"
            maxLength={cardDetails.maxCvvLength}
            hasError={cardDetails.invalidCvv}
            errorMsg="Invalid CVV"
            onBlur={validateCVV}
            dataPrivate="lipsum"
          />
          <Icon
            class="desktop-add-new-card--card-cvv--inline-icon icon-payment-cvv"
            size={20}
            onClick={() => showCvvModalVisible(true)}
          />
        </div>
        <Input
          type="text"
          className="desktop-add-new-card--name"
          onChange={({ name }) => setCardDetails({ ...cardDetails, name })}
          value={cardDetails.name}
          name="name"
          placeholder="Name on Card *"
          maxLength={30}
          hasError={cardDetails.invalidName}
          errorMsg="Please add name"
          onBlur={validateName}
        />
        {source !== SOURCE.ACCOUNTS && (
          <div
            className="desktop-add-new-card--save-card"
            onClick={() =>
              setCardDetails({
                ...cardDetails,
                saveCard: !cardDetails.saveCard,
              })
            }
          >
            <span>Securely save card details</span>
            {cardDetails.saveCard ? (
              <Icon class="icon-common-checkbox-selected" size={20} />
            ) : (
              <Icon class="icon-common-checkbox-unselected" size={20} />
            )}
          </div>
        )}
        {source !== SOURCE.ACCOUNTS && (
          <Button
            className="button button-primary full-width large"
            onClick={onPay}
          >
            {cardDetails.saveCard ? 'Save & ' : ''} {ctaText}
          </Button>
        )}
        {source === SOURCE.ACCOUNTS && (
          <Button
            className="button button-primary full-width large"
            onClick={saveCard}
          >
            Save this card
          </Button>
        )}
      </Drawer>
      <SimpleModal
        visible={cvvModalVisible}
        onCancel={() => showCvvModalVisible(false)}
        wrapClassName="desktop-cvv-modal"
        title="What is CVV?"
      >
        <div>
          <Icon
            src={cvvIllustration}
            width={252}
            height={143}
            class="desktop-cvv-modal--icon"
          />
          <div className="desktop-cvv-modal--content">
            CVV is the 3 digit or 4 digit number on the back of your
            Debit/Credit Card
          </div>
        </div>
      </SimpleModal>
    </React.Fragment>
  );
};

const mapDispatchToProps = {
  setAppNotification,
};

export default connect(null, mapDispatchToProps)(Cards);
